export var device = {
    notMobile: '(min-width: 768px)',
    tablet: '(min-width: 992px)',
    desktop: '(min-width: 1216px)',
    large: '(min-width: 1408px)',
    xLarge: '(min-width: 1921px)',
};
